import { CheckboxField, type CheckboxFieldProps, Typography } from '@sunwebgroup/ui-components/uds'
import get from 'lodash/get'
import { Controller, FieldError, useFormContext } from 'react-hook-form'
import styles from './CheckboxInput.module.css'

export interface FormCheckboxProps extends CheckboxFieldProps {
  name: string
  validationMessage?: string
  value?: string
}

export function CheckboxInput({
  name,
  validationMessage,
  value,
  ...restProps
}: FormCheckboxProps) {
  const {
    control,
    formState,
  } = useFormContext()
  const { errors } = formState
  const fieldError = get(errors, name) as FieldError | undefined
  const errorMessage = fieldError?.message as string | undefined
  const hasError = !!fieldError

  return (
    <div className={styles.formCheckboxContainer}>
      <Controller
        name={name}
        control={control}
        rules={{
          required: validationMessage,
        }}
        render={({ field }) => (
          <CheckboxField
            {...restProps}
            checked={field.value ?? false}
            value={value}
            onCheckedChange={checked => field.onChange(value ?? checked)}
            error={hasError}
            id={field.name}
          />
        )}
      />
      {hasError && errorMessage && (
        <Typography forwardedAs="p" variant="body-s-bold-snug" className={styles.errorMessage}>{errorMessage}</Typography>
      )}
    </div>
  )
}
